/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maca_MaximizeInputs */

const en_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximize`)
};

const ar_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكبير`)
};

const bn_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ম্যাক্সিমাইজ করুন`)
};

const de_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximieren`)
};

const es_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximizar`)
};

const fr_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximiser`)
};

const pt_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximizar`)
};

const zh_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大化`)
};

const tr_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büyüt`)
};

const ru_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развернуть`)
};

const pl_maca_maximize = /** @type {(inputs: Maca_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksymalizuj`)
};

/**
* | output |
* | --- |
* | "Maximize" |
*
* @param {Maca_MaximizeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const maca_maximize = /** @type {((inputs?: Maca_MaximizeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maca_MaximizeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_maca_maximize(inputs)
	if (locale === "bn") return bn_maca_maximize(inputs)
	if (locale === "de") return de_maca_maximize(inputs)
	if (locale === "es") return es_maca_maximize(inputs)
	if (locale === "fr") return fr_maca_maximize(inputs)
	if (locale === "pt") return pt_maca_maximize(inputs)
	if (locale === "zh") return zh_maca_maximize(inputs)
	if (locale === "tr") return tr_maca_maximize(inputs)
	if (locale === "ru") return ru_maca_maximize(inputs)
	if (locale === "pl") return pl_maca_maximize(inputs)
	return en_maca_maximize(inputs)
});